import { render, staticRenderFns } from "./ElderlyData.vue?vue&type=template&id=69113c59&scoped=true&"
import script from "./ElderlyData.vue?vue&type=script&lang=js&"
export * from "./ElderlyData.vue?vue&type=script&lang=js&"
import style0 from "./ElderlyData.vue?vue&type=style&index=0&id=69113c59&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69113c59",
  null
  
)

export default component.exports